import React from 'react'

function Alert(props) {

    
    
    const capitalize = (word) => {
        const lower = word.toLowerCase();
        return lower.charAt(0).toUpperCase() + lower.slice(1);
      };
    
    return (
  

  <div className="heightContainer" style = {{height:'50px'}}  >
    
  {  props.alert && <div>

<div className={`alert alert-${props.alert.typeOfAlert} alert-dismissible fade show `} role="alert">

  <strong>{capitalize(props.alert.typeOfAlert)}</strong> : {props.alert.msg}
    
</div>

    
    
</div>}

      
    </div>
  )
}

export default Alert
